/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { useSelector } from "react-redux"

import { RootState } from "../../../../globalStore/rootreducer"
import {
  TKenkoSindanKirokuData,
  TAnzenKaigiKirokuData,
  TTekiseiSindanKirokuData,
} from "../../../../globalStore/pageStore/zyomuinMaster/kyoikuKensyuJusinData"
import CONSTANT from "../../../../constant"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"
import dateUtil from "../../../../ts/util/dateUtil"

/**
 * 教育研修受信Accordion
 */
const KyoikuKensyuJusinPane = () => {
  //#region [selector]
  const zyomuinMaster = useSelector(
    (state: RootState) => state.page.zyomuinMaster
  )

  //#endregion

  //#region [method]

  // 健康診断記録CollectionView
  const createCollectionViewKenkoSindanKiroku = (
    data: TKenkoSindanKirokuData[]
  ) => new wjcCore.CollectionView(data)
  // 健康診断記録_初期化
  const initGridKenkoSindanKiroku = (grid: wjcGrid.FlexGrid) => {
    setFlexGridKenkoSindanKiroku(grid)
  }

  // 安全会議記録CollectionView
  const createCollectionViewAnzenKaigiKiroku = (
    data: TAnzenKaigiKirokuData[]
  ) => new wjcCore.CollectionView(data)
  // 安全会議記録_初期化
  const initGridAnzenKaigiKiroku = (grid: wjcGrid.FlexGrid) => {
    setFlexGridAnzenKaigiKiroku(grid)
  }

  // 適性診断記録CollectionView
  const createCollectionViewTekiseiSindanKiroku = (
    data: TTekiseiSindanKirokuData[]
  ) =>
    new wjcCore.CollectionView<TTekiseiSindanKirokuData>(data, {
      calculatedFields: {
        実施年齢: (i: TTekiseiSindanKirokuData) => {
          const 実施年齢 = dateUtil.calc年齢(i.実施日, i.生年月日)
          return 実施年齢 == null ? "" : `${実施年齢}歳`
        },
      },
    })
  // 適性診断記録_初期化
  const initGridTekiseiSindanKiroku = (grid: wjcGrid.FlexGrid) => {
    setFlexGridTekiseiSindanKiroku(grid)
  }

  //#endregion

  // #region [state]
  // 健康診断記録
  const [itemsSourceKenkoSindanKiroku, setItemsSourceKenkoSindanKiroku] =
    useState<wjcCore.CollectionView<TKenkoSindanKirokuData>>(
      createCollectionViewKenkoSindanKiroku([
        ...zyomuinMaster.健康診断記録データリスト,
      ])
    )
  const [flexGridKenkoSindanKiroku, setFlexGridKenkoSindanKiroku] =
    useState<wjcGrid.FlexGrid>()

  // 安全会議記録
  const [itemsSourceAnzenKaigiKiroku, setItemsSourceAnzenKaigiKiroku] =
    useState<wjcCore.CollectionView<TAnzenKaigiKirokuData>>(
      createCollectionViewAnzenKaigiKiroku([
        ...zyomuinMaster.安全会議記録データリスト,
      ])
    )
  const [flexGridAnzenKaigiKiroku, setFlexGridAnzenKaigiKiroku] =
    useState<wjcGrid.FlexGrid>()

  // 適性診断記録
  const [itemsSourceTekiseiSindanKiroku, setItemsSourceTekiseiSindanKiroku] =
    useState<wjcCore.CollectionView<TTekiseiSindanKirokuData>>(
      createCollectionViewTekiseiSindanKiroku([
        ...zyomuinMaster.適正診断記録データリスト,
      ])
    )
  const [flexGridTekiseiSindanKiroku, setFlexGridTekiseiSindanKiroku] =
    useState<wjcGrid.FlexGrid>()

  //#endregion

  //#region [effect]
  useEffect(() => {
    setItemsSourceKenkoSindanKiroku(
      createCollectionViewKenkoSindanKiroku([
        ...zyomuinMaster.健康診断記録データリスト,
      ])
    )
    setItemsSourceAnzenKaigiKiroku(
      createCollectionViewAnzenKaigiKiroku([
        ...zyomuinMaster.安全会議記録データリスト,
      ])
    )
    setItemsSourceTekiseiSindanKiroku(
      createCollectionViewTekiseiSindanKiroku([
        ...zyomuinMaster.適正診断記録データリスト,
      ])
    )

    flexGridKenkoSindanKiroku?.refresh()
    flexGridAnzenKaigiKiroku?.refresh()
    flexGridTekiseiSindanKiroku?.refresh()
  }, [
    zyomuinMaster.健康診断記録データリスト,
    zyomuinMaster.安全会議記録データリスト,
    zyomuinMaster.適正診断記録データリスト,
  ])
  //#endregion

  return (
    <>
      <div className="accordion-header">
        健康診断・安全会議・適性診断
        <div className="accordion-description">教育・研修・受診</div>
      </div>
      <div>
        <Row>
          <Col>
            <h5>健康診断記録</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                    initialized={initGridKenkoSindanKiroku}
                    itemsSource={itemsSourceKenkoSindanKiroku}>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="受診日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      header="受診日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TKenkoSindanKirokuData>
                        ) => {
                          return dateUtil.format(context.item.受診日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="医療機関"
                      width={300}
                      header="医療機関"></wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5>安全会議記録</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                    initialized={initGridAnzenKaigiKiroku}
                    itemsSource={itemsSourceAnzenKaigiKiroku}>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="実施日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      format="d"
                      header="出席日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TAnzenKaigiKirokuData>
                        ) => {
                          return dateUtil.format(context.item.実施日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="会議名"
                      width={300}
                      header="会議名"></wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5>適性診断記録</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                    initialized={initGridTekiseiSindanKiroku}
                    itemsSource={itemsSourceTekiseiSindanKiroku}>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="実施日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      format="d"
                      header="実施日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TTekiseiSindanKirokuData>
                        ) => {
                          return dateUtil.format(context.item.実施日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="実施年齢"
                      width={120}
                      header="実施年齢"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="適性診断種類区分名称1"
                      width={100}
                      header="種類"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="否判定結果"
                      width={300}
                      header="不足点"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="実施機関"
                      width={100}
                      header="実施機関"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="所見"
                      width={500}
                      header="所見"></wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default KyoikuKensyuJusinPane
